<template>
  <div id="index" class="image-view">
    <img
      v-for="(item, index) of fileList"
      :key="index"
      class="image-view-item"
      :src="item"
      alt="图片描述"
    />
  </div>
</template>

<script>
import Viewer from 'viewerjs'
import 'viewerjs/dist/viewer.css'
export default {
  name: 'ImgView',
  props: {
    fileList: {
      type: Array,
      default: () => []
    }
  },
  mounted() {
    const ViewerDom = document.getElementById('index')
    const viewer = new Viewer(ViewerDom, {
      // 相关配置项,详情见下面
      inline: false,
      viewed() {}
    })
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.image-view {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
  &-item {
    background-color: white;
    flex: 0 0 100px;
    width: 100px;
    height: 100px;
    margin: 10px;
    cursor: pointer;
  }
}
</style>
